import BackIcon from '@mui/icons-material/ArrowBack';
import AppBar from '@mui/material/AppBar';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { FormattedMessage, useIntl } from 'react-intl';
import { getRouteApi, Link } from '@tanstack/react-router';
import AbsenceList from '~/components/AbsenceList';
import AvailabilityList from '~/components/AvailabilityList';
import ContentView from '~/components/ContentView';
import DrawerButton from '~/containers/DrawerButton';
import Spacings from '~/modules/ui-kit/spacings';
import messages from './messages';
import { usePublisherMe } from '~/hooks/api/usePublisherMe';

const route = getRouteApi('/availability/');

const Availability = () => {
  const intl = useIntl();
  const publisherQuery = usePublisherMe();
  const query = route.useSearch();
  const previousPage = query.from;
  const publisherId = query.publisherId || publisherQuery.data?.id.toString();

  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <Grid
              container
              spacing={2}
              sx={{
                alignItems: 'center',
              }}
            >
              <Grid>
                {previousPage ? (
                  <IconButton
                    color="inherit"
                    href=""
                    component={Link}
                    to={previousPage}
                    aria-label={intl.formatMessage(messages.back)}
                    size="large"
                  >
                    <BackIcon />
                  </IconButton>
                ) : (
                  <DrawerButton />
                )}
              </Grid>
              <Grid>
                <Typography
                  variant="h6"
                  sx={{
                    color: 'inherit',
                  }}
                >
                  <FormattedMessage {...messages.title} />
                </Typography>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      }
      isLoading={publisherQuery.isLoading}
    >
      <Spacings.Inset>
        <Typography variant="h6">
          <FormattedMessage {...messages.timesForAutomaticApplications} />
        </Typography>
      </Spacings.Inset>
      {publisherId ? (
        <AvailabilityList publisherId={parseInt(publisherId, 10)} />
      ) : null}
      <Divider />
      <Spacings.Inset>
        <Typography variant="h6">
          <FormattedMessage {...messages.absences} />
        </Typography>
      </Spacings.Inset>
      {publisherId ? (
        <AbsenceList publisherId={parseInt(publisherId, 10)} />
      ) : null}
    </ContentView>
  );
};

export default Availability;
